/** axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from "axios";

import { Message } from "element-ui";
import router from "@/router";
// import baseURL from "@/config";
// import store from "../store/index";
import Cookies from 'js-cookie'


function download(content, fileName) {
  const blob = new Blob([content]); //创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
  const url = window.URL.createObjectURL(blob); //URL.createObjectURL(object)表示生成一个File对象或Blob对象
  let dom = document.createElement("a"); //设置一个隐藏的a标签，href为输出流，设置download
  dom.style.display = "none";
  dom.href = url;
  dom.setAttribute("download", fileName); //指示浏览器下载url,而不是导航到它；因此将提示用户将其保存为本地文件
  document.body.appendChild(dom);
  dom.click();
}



function Toast(str) {
  Message({
    type: "error",
    message: str
  });
}

const HTTP_CONFIG = {
  timeout: 40000,
  crossOrigin: true
};

Object.entries(HTTP_CONFIG).forEach(([key, value]) => {
  axios.defaults[key] = value;
});

// axios.defaults.baseURL = baseURL

// 请求超时时间
// axios.defaults.timeout = 20000

// 请求拦截器
axios.interceptors.request.use(
  config => {
    // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
    const token = Cookies.get('token')
    token && (config.headers.token = token)

    return config;
  },
  error => {
    return Promise.error(error);
  }
);

// 响应拦截器
axios.interceptors.response.use(
  response => {
    const { status, data, config } = response;
    if (config.responseType === "blob") {
      return Promise.resolve(response);
    }

    if (status === 200 && data.success) {
      return Promise.resolve(response);
    }

    Toast(data.message);
    return Promise.reject(response);
  },
  // 服务器状态码不是200的情况
  error => {
    if (error.response) {
      switch (error.response.status) {
        // 401: 未登录
        // 未登录则跳转登录页面，并携带当前页面的路径
        // 在登录成功后返回当前页面，这一步需要在登录页操作。
        case 401:
          router.replace({
            path: "/login",
            query: { redirect: router.currentRoute.fullPath }
          });
          break;
        default:
          Toast(error.response.data.message);
      }

      return Promise.reject(error.response.data);
    } else {
      // Toast('NETWORK ERROR');
      Toast(error);
    }
  }
);
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */

export function post(url, params, type = false, conf = {}) {
  return new Promise((resolve, reject) => {
    if (!type) {
      axios
        .post(url, params, conf)
        .then(res => {
          resolve(res.data)
        })
        .catch(err => {
          reject(err.data)
        })
    } else {
      let paramsStr = '?'
      for (const key in params) {
        paramsStr += `${key}=${params[key]}&`
      }
      paramsStr = paramsStr.slice(0, paramsStr.length - 1)
      axios
        .post(url + paramsStr)
        .then(res => {
          resolve(res.data)
        })
        .catch(err => {
          reject(err.data)
        })
    }

  })
}

/**
 * put方法，对应put请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function put(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .put(url, params)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
}

/**
 * remove方法，对应delete请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function remove(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .delete(url, {
        params: params
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
}

export function fileDown(url, data, fileName = "") {
  return new Promise((resolve, reject) => {
    axios({
      method: "post", //请求方式
      url,
      data, //请求参数
      responseType: "blob" //服务器返回的数据类型
    }).then(response => {
      const content = response.data; //返回的内容
      download(content, fileName);
      resolve(); // 异步操作成功时调用 resolve
    }).catch(error => {
      console.error(error);
      reject(error); // 异步操作失败时调用 reject
    });
  });
}
